import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import CtaLinkList from '@/components/organisms/cta-link-list/cta-link-list';
import TravelPlan from '@/components/organisms/travel-plan/travel-plan';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import styles from './travel-plan-module.module.scss';

export interface TravelPlanModuleProps extends ModuleWrapperProps {
  /** An array of links to show */
  ctaLinks?: Content.Components['TravelPlanModuleDto']['ctaLinks'];
  /** The text to show as a headline */
  headline?: Content.Components['TravelPlanModuleDto']['headline'];
  /** The UUID of the module */
  id: Content.Components['TravelPlanModuleDto']['id'];
  /** The UUID of the current page */
  pageId: Content.Components['TravelPlanModuleDto']['pageId'];
  /** The text to show as a sub headline */
  subHeadline?: Content.Components['TravelPlanModuleDto']['subHeadline'];
  /** The text to show as a description */
  text?: Content.Components['TravelPlanModuleDto']['text'];
  /** The travel plan information to show */
  travelPlan?: Content.Components['TravelPlanModuleDto']['travelPlan'];
}

const TravelPlanModule = ({
  ctaLinks = [],
  headline,
  subHeadline,
  text,
  travelPlan,
  ...rest
}: TravelPlanModuleProps) => {
  return (
    <ModuleWrapper {...rest} className={styles.component}>
      <Container className={styles.container}>
        {(ctaLinks.length > 0 || headline || subHeadline || text) && (
          <Row>
            <Column className={styles.headlineColumn} width={{ laptop: 6 }}>
              {headline && (
                <Typography
                  className={styles.headline}
                  tag="h2"
                  tagStyle="displayMedium"
                >
                  {headline}
                </Typography>
              )}

              {subHeadline && (
                <Typography
                  className={styles.subHeadline}
                  tag="h3"
                  tagStyle="bodyLargeBold"
                >
                  {subHeadline}
                </Typography>
              )}

              {text && <RichText text={text} />}

              {ctaLinks.length > 0 && <CtaLinkList items={ctaLinks} />}
            </Column>
          </Row>
        )}

        <TravelPlan travelPlan={travelPlan} />
      </Container>
    </ModuleWrapper>
  );
};

TravelPlanModule.displayName = 'TravelPlanModule';

export default TravelPlanModule;
